import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/xuanhuan', label: '分类' },
    { to: '/article/1', label: '资讯' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="text-2xl md:text-3xl font-heading text-primary-500">
              虫虫漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              type="button"
              className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-foreground-700 bg-background-100 rounded-full hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
              aria-label="搜索漫画"
            >
              <i className="ri-search-line w-4 h-4 flex items-center justify-center"></i>
              <span>搜索</span>
            </button>
            <Link
              to="/about"
              className="px-5 py-2 text-sm font-medium text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
          </div>

          <button
            type="button"
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/70 bg-background-50 animate-fade-in-up">
            <div className="py-4 px-2 flex flex-col gap-2">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                    location.pathname === link.to
                      ? 'text-primary-500 bg-primary-50'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <div className="pt-3 flex flex-col gap-2">
                <button
                  type="button"
                  className="w-full px-4 py-3 text-sm font-medium text-foreground-700 bg-background-100 rounded-lg hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-search-line mr-2"></i>
                  搜索漫画
                </button>
                <Link
                  to="/about"
                  className="w-full px-4 py-3 text-sm font-medium text-background-50 bg-primary-500 rounded-lg hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
                >
                  开始阅读
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}